import React from "react";
import Container from "@ui/container";
import ComplexText from "@ui/complex-text";

const ComplexTextWidget = ({ data }) => {
    const { values } = data;
    return (
        <Container>
            <ComplexText values={values} ></ComplexText>
        </Container>
    );
};

export default ComplexTextWidget;
